export class StaticPage {
    id: string;
    id_original: number;
    alias: string;
    originalFileName: string;
    heading: string;
    contents: string;
    contentPreview: string;
    lastUpdated: Date;
}